import { Crown } from "lucide-react";

export function PremiumBadge({ size = "sm", className = "" }) {
  const cls = size === "lg" ? "text-[10px] px-3 py-1.5 gap-2" : "text-[8px] px-2 py-0.5 gap-1";
  return (
    <span data-testid="vcb-premium-badge"
          className={`inline-flex items-center ${cls} font-grotesk uppercase tracking-[0.3em] text-black bg-[#D8B23E] shadow-[0_0_14px_-3px_rgba(216,178,62,0.9)] ${className}`}>
      <Crown size={size === "lg" ? 12 : 9} strokeWidth={2.4} /> Premium
    </span>
  );
}

export function PremiumFrame({ children, className = "", testid }) {
  return (
    <div data-testid={testid}
         className={`relative rounded-sm border border-[#D8B23E]/70 bg-[#0A0804] shadow-[0_0_0_1px_rgba(216,178,62,0.15),0_30px_80px_-30px_rgba(216,178,62,0.35)] ${className}`}>
      <div className="pointer-events-none absolute inset-0 rounded-sm bg-[radial-gradient(900px_300px_at_100%_0%,rgba(216,178,62,0.10),transparent_70%)]" />
      <div className="relative">{children}</div>
    </div>
  );
}
